export class KafkaConnectProbeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "brokerCount",
            "baseName": "brokerCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "clusterId",
            "baseName": "clusterId",
            "type": "string",
            "format": ""
        },
        {
            "name": "latencyMs",
            "baseName": "latencyMs",
            "type": "number",
            "format": ""
        },
        {
            "name": "kafkaVersion",
            "baseName": "kafkaVersion",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaConnectProbeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
